import API from 'services/API';

export default function setIsRead(notificationId) {
  return API.request({
    method: 'POST',
    url: '/notification/setRead',
    headers: {
      'Content-Type': 'application/json;charset=UTF-8',
    },
    params: {
      notificationId,
    },
  });
}
